export enum EStages {
  "lobby" = "lobby",
  "add_songs" = "add_songs",
  "vote" = "vote",
  "results" = "results",
}

export type TMusicMafiaURL = {
  roomId?: string;
}